import CustomerRefundShipmentsApiV2 from 'api/v2/admins/customer-refund-shipments-api-v2'
import CustomerRefundsApiV2 from 'api/v2/admins/customer-refunds-api-v2'
import TitlePage from 'components/atoms/title-page'
import { ALERT_TYPES } from 'constants/alert-constants'
import CustomerRefundShipmentCreateForm from 'domains/customer-refund-shipment/organisms/create-form'
import CustomerRefundShippableTable from 'domains/customer-refund/organisms/shippable-table'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import {
  Card,
  CardHeader
} from 'reactstrap'


const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CustomerRefundShipmentCreatePage = ({ pageUtils }) => {
  const [ refundShippable, setRefundShippable ]                 = useState([])
  const [ selectedRefunds, setSelectedRefunds ]                 = useState([])
  const [ selectedCustomer, setSelectedCustomer ]               = useState({})
  const [ selectedShippingAddress, setSelectedShippingAddress ] = useState({})
  const history                                                 = useHistory()

  useEffect(() => {
    CustomerRefundsApiV2.shippable({})
      .then((response) => {
        setRefundShippable(response.data.refunds)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }, [ pageUtils ])

  /**
   * Handler to add/remove Customer Refund.
   * @param {*} datum selected row record
   */
  const handleSelectRow = (datum) => {
    setRefundShippable(refundShippable.filter((item) => item !== datum ))
    setSelectedRefunds((prev) => [ ...prev, datum ])
    setSelectedCustomer(datum.customer)
    setSelectedShippingAddress(datum.shipping_address)
  }

  /**
   * Remove selected Refund to be shipped
   * @param {object} datum selected row record
   */
  const handleRemoveRow = (datum) => {
    setRefundShippable([ datum, ...refundShippable ])

    const currentSelectedRefunds = selectedRefunds.filter((refund) => refund.id !== datum.id)
    setSelectedRefunds(currentSelectedRefunds)

    if (currentSelectedRefunds.length == 0){
      setSelectedCustomer({})
      setSelectedShippingAddress({})
    }
  }

  /**setSelectedCustomer
   * Handler submit to create Customer Refund Shipment
   * @param {object} values Formikbag values
   */
  const handleSubmit = async (values) => {

    CustomerRefundShipmentsApiV2.create({
      values              : values,
      refund_ids          : selectedRefunds.map((refund) => refund.id),
      shipping_address_id : selectedShippingAddress.id
    })
      .then(() => {
        pageUtils.setAlertMsg('Shipment has been Created', ALERT_TYPES.SUCCESS)
        history.goBack()
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }

  /**
   * Disable available Customer Refund that not have identical Customer and Shipping with current selected Customer Refund
   * @param {object} datum - ReactTable row record
   */
  const isNotSameCustomerAndShippingAddress = useCallback((datum) => {
    // For old refund data from customer that not account link yet, the button will be disabled.
    // Because now order.shipping_address = UserAddress and refund process need UserAddress instead of Customer::Address
    const isRefundHaveUserAddress = datum.shipping_address
    if (!isRefundHaveUserAddress) return true

    const isNotIdenticalCustomer        = selectedCustomer?.id !== datum.customer.id
    const isNotIdenticalShippingAddress = selectedShippingAddress?.id !== datum.shipping_address?.id

    return (selectedRefunds.length !== 0 && (isNotIdenticalCustomer || isNotIdenticalShippingAddress))
  }, [ selectedRefunds.length, selectedCustomer?.id, selectedShippingAddress?.id ])

  return (
    <>
      <TitlePage mainTitle={ 'Customer Refund Shipment' } subTitle={ 'Create Page' } />

      <Card>
        <CardHeader>
          <h2>{ 'Available Refund to Ship' }</h2>
        </CardHeader>
        <CustomerRefundShippableTable
          data={ refundShippable }
          rowButtonProps={{
            buttonText       : 'Select',
            buttonColour     : 'primary',
            isButtonDisabled : isNotSameCustomerAndShippingAddress,
            onButtonClick    : handleSelectRow
          }}
        />
      </Card>

      {
        selectedRefunds.length > 0
          ? (
            <>
              <Card>
                <CardHeader>
                  <h2>{ 'Selected Refund to Ship' }</h2>
                </CardHeader>
                <CustomerRefundShippableTable
                  data={ selectedRefunds }
                  rowButtonProps={{
                    buttonText    : 'Remove',
                    buttonColour  : 'danger',
                    onButtonClick : handleRemoveRow
                  }}
                />
              </Card>

              <Card body>
                <h2 className="pb-4">{ 'Create Shipment Form' }</h2>
                <CustomerRefundShipmentCreateForm onSubmit={ handleSubmit } />
              </Card>
            </>
          )
          : null
      }
    </>
  )
}

CustomerRefundShipmentCreatePage.propTypes    = propTypes
CustomerRefundShipmentCreatePage.defaultProps = defaultProps

export default CustomerRefundShipmentCreatePage
